import CloseIcon from '@mui/icons-material/Close'
import { Box, Button, IconButton, Paper, Typography, useMediaQuery } from '@mui/material'
import { useEffect, useState } from 'react'
import { getAppConfig } from '../globalHeader/services/AppConfigService'
import { isProd } from '../helpers/isProd'
import { isIOS, isIOSSafari } from '../utils/detectBrowser'
import { Icon } from './Icon'

export const AppBanner = () => {
    const [isVisible, setIsVisible] = useState(false)
    const isMobile = useMediaQuery('(max-width: 768px)', { noSsr: true })

    useEffect(() => {
        const config = getAppConfig()
        if (config?.isMobileApp || !isMobile || isIOSSafari()) {
            setIsVisible(false)
            return
        }

        const bannerClosedAt = localStorage.getItem('appBannerClosedAt')
        if (bannerClosedAt) {
            const closedTime = new Date(bannerClosedAt).getTime()
            const now = new Date().getTime()
            const days = isProd ? 1 : 1 // Show for 1 days in production, 1 day in development
            const cooldown = days * 24 * 60 * 60 * 1000 // 1 or 1 days in milliseconds

            if (now - closedTime < cooldown) {
                setIsVisible(false)
            } else {
                localStorage.removeItem('appBannerClosedAt')
                setIsVisible(true)
            }
        } else {
            setIsVisible(true)
        }
    }, [isMobile])

    const handleOpenApp = () => {
        if (isIOS()) {
            window.open('https://apps.apple.com/us/app/chess-at-icc-play-learn/id643326555', '_blank')
        } else {
            window.open('https://play.google.com/store/apps/details?id=com.chessclub.android', '_blank')
        }
    }

    const handleCloseBanner = () => {
        localStorage.setItem('appBannerClosedAt', new Date().toISOString())
        setIsVisible(false)
    }

    if (!isVisible) {
        return null
    }

    return (
        <Paper
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 2000,
                padding: 1,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderRadius: '0 !important',
                backgroundColor: '#fff',
                filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.3))',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 1,
                    width: '100%',
                }}
            >
                <Box display="flex" alignItems="center" gap={1}>
                    <IconButton sx={{ padding: 0, color: 'text.disabled' }} onClick={handleCloseBanner} size="small">
                        <CloseIcon />
                    </IconButton>
                    <Icon />
                    <Box display="flex" flexDirection="column">
                        <Typography
                            color="common.black"
                            fontSize="16px"
                            lineHeight="18px"
                            textTransform="none"
                            variant="h6"
                        >
                            Chess at ICC, play & learn
                        </Typography>
                        <Typography fontSize="12px" lineHeight="14px" color="text.disabled" variant="body2">
                            The Original ICC App
                        </Typography>
                    </Box>
                </Box>
                <Button
                    sx={{
                        minWidth: '68px !important',
                        maxWidth: '68px !important',
                        fontSize: '16px !important',
                        backgroundColor: '#007aff !important',
                        color: '#fff !important',
                        borderRadius: '24px',
                    }}
                    variant="contained"
                    color="primary"
                    onClick={handleOpenApp}
                >
                    Open
                </Button>
            </Box>
        </Paper>
    )
}
